import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { catalogosRoutesMap } from './CatalogosRoutesMap'

const AppProductoServicio = Loadable(
  lazy(() => import('./view/ProductoServicio/ProductoServicio')),
)
const AppMetodoPago = Loadable(lazy(() => import('./view/MetodoPago/MetodoPago')))

const catalogosRoutes = [
  {
    path: catalogosRoutesMap.productoServicio.path,
    element: <AppProductoServicio />,
    auth: authRoles.admin,
  },
  {
    path: catalogosRoutesMap.metodoPago.path,
    element: <AppMetodoPago />,
    auth: authRoles.admin,
  },
]

export default catalogosRoutes
